export const business = {
  name: 'Soundside Marine Services',
  phone: '252-482-4363',
  tel: 'tel:+12524824363',
  sms: 'sms:2524824363',
  email: 'michael@soundsidemarine.com',
  street: '114 Marine Drive',
  city: 'Edenton',
  state: 'NC',
  zip: '27932',
  directions: 'https://www.google.com/maps/dir/?api=1&destination=114+Marine+Drive+Edenton+NC+27932',
  mapEmbed: 'https://www.google.com/maps?q=114+Marine+Drive,+Edenton,+NC+27932&output=embed',
  logo: 'https://img1.wsimg.com/isteam/ip/6aeb6314-f9bd-4040-b2c4-a429ea14e1af/blob-8852a02.png',
};

export const hours = [
  { day: 'Mon – Thu', time: '8:00 AM – 4:00 PM' },
  { day: 'Friday', time: '8:00 AM – 12:00 PM' },
  { day: 'Sat – Sun', time: 'Closed' },
];

export const navLinks = [
  { label: 'Repowers', href: '#repowers' },
  { label: 'Service', href: '#service' },
  { label: 'Engines', href: '#engines' },
  { label: 'Storage', href: '#storage' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
];

export const footerLinks = [
  { label: 'Repowers', href: '#repowers' },
  { label: 'Service', href: '#service' },
  { label: 'Engines', href: '#engines' },
  { label: 'Pre-Owned', href: '#pre-owned' },
  { label: 'Storage', href: '#storage' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
];

export const safetyLinks = [
  { label: 'U.S. Coast Guard Boating', href: 'https://uscgboating.org' },
  { label: 'BoatingSafety.com', href: 'https://www.boatingsafety.com' },
  { label: 'Boating Basics Online', href: 'https://www.boatingbasicsonline.com' },
];

export const images = {
  michaelBoat: 'https://img1.wsimg.com/isteam/ip/6aeb6314-f9bd-4040-b2c4-a429ea14e1af/michaelboat.jpg',
  goldenHour: 'https://cdn.magicpatterns.com/patterns/generated-images/91c02cdc-39a4-496a-bb57-7b3b3f00d887.jpg',
  twinOutboards: 'https://cdn.magicpatterns.com/patterns/generated-images/e72a4d4c-b894-4b3e-9b5f-afbe271affd4.jpg',
  bayBoatMarsh: 'https://cdn.magicpatterns.com/patterns/generated-images/3f81f9ee-891f-4579-8881-c12e5082fc7c.jpg',
  repowerRigging: 'https://cdn.magicpatterns.com/patterns/generated-images/4c5a8786-281a-4287-8b74-7b24c0205a48.jpg',
  beforeOutboard: 'https://cdn.magicpatterns.com/patterns/generated-images/3ea5ad7e-fd47-4daa-b49c-8a575db66e84.jpg',
  afterOutboard: 'https://cdn.magicpatterns.com/patterns/generated-images/2990d887-3586-438a-8a35-f403109b2d47.jpg',
  preOwned: 'https://cdn.magicpatterns.com/patterns/generated-images/61d67db8-29f7-47e3-af4b-99b16e2167bd.jpg',
  testTank: 'https://cdn.magicpatterns.com/patterns/generated-images/dbf5f491-d903-422c-8dcf-1998cd446c01.jpg',
  fleet: 'https://cdn.magicpatterns.com/patterns/generated-images/9dc8563d-2547-4112-aa48-3e79b7ad5834.jpg',
  storage: 'https://cdn.magicpatterns.com/patterns/generated-images/0d4190c4-0f9f-476a-af6b-214d444387f0.jpg',
  serviceArea: 'https://cdn.magicpatterns.com/patterns/generated-images/fee95a8a-a5ea-423d-a832-66e594004c44.jpg',
  breatherWake: 'https://cdn.magicpatterns.com/patterns/generated-images/e425d721-4e29-48a1-8555-91fe5465d1b0.jpg',
  breatherHarbor: 'https://cdn.magicpatterns.com/patterns/generated-images/b0a194af-da7c-46f4-9153-8bed27072c1c.jpg',
};

// Paste the direct .mp4 URL of the background video from the current soundsidemarine.com homepage into `src`.
// Until it's set, the video option shows the poster photo instead.
export const heroVideo = {
  src: '',
  poster: images.michaelBoat,
  alt: 'Center console boat running across open water near Edenton, North Carolina',
};

export const heroSlides = [
  {
    src: images.michaelBoat,
    alt: 'Center console boat on open water under a clear blue sky near Edenton, North Carolina',
  },
  {
    src: images.goldenHour,
    alt: 'Center console fishing boat running fast across calm sound water at golden hour, wake spraying behind',
  },
  {
    src: images.twinOutboards,
    alt: 'Twin outboard motors on a boat transom at sunrise in a quiet harbor',
  },
  {
    src: images.bayBoatMarsh,
    alt: 'Bay boat idling on a wide, glassy North Carolina sound with marsh grass in the foreground',
  },
];

export const dealerLogos = [
  {
    name: 'Yamaha Outboards',
    src: 'https://img1.wsimg.com/isteam/ip/6aeb6314-f9bd-4040-b2c4-a429ea14e1af/blob-491a61b.png',
  },
  {
    name: 'Honda Marine',
    src: 'https://img1.wsimg.com/isteam/ip/6aeb6314-f9bd-4040-b2c4-a429ea14e1af/blob-517ed56.png',
  },
];

export const repowerSteps = [
  { title: 'Tell us your boat', text: 'Year, make, length and what’s hanging on the transom now.' },
  { title: 'We spec and quote the right motor', text: 'Yamaha or Honda, matched to your hull and how you run it.' },
  { title: 'We rig, test and hand it back', text: 'Rigged in-house and run in our drive-in test tank first.' },
];

export const engines = [
  {
    brand: 'Yamaha',
    model: 'F15SEHA',
    shaft: '15" shaft',
    hp: '15 HP',
    summary: '4-stroke portable with electric start and tiller steering.',
    specs: ['15 HP 4-stroke portable', 'Electric start', 'Tiller steering'],
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/a0e8b231-0d2c-4884-9cd5-6293fe17c421.jpg',
    alt: 'Portable 15 horsepower tiller outboard motor on a light background',
  },
  {
    brand: 'Yamaha',
    model: 'F70LB',
    shaft: '20" shaft',
    hp: '70 HP',
    summary: 'Inline 4-cylinder 4-stroke with remote control and power trim & tilt.',
    specs: ['70 HP inline 4-cylinder 4-stroke', 'Remote control', 'Power trim & tilt'],
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/a708d71c-72ba-462b-835c-2f714e9513d3.jpg',
    alt: 'Mid-size 70 horsepower remote-control outboard motor on a light background',
  },
  {
    brand: 'Yamaha',
    model: 'F90LB',
    shaft: '20" shaft',
    hp: '90 HP',
    summary: '1.8L inline 4-cylinder 4-stroke, Command Link compatible.',
    specs: ['1.8L inline 4-cylinder 4-stroke', 'Remote control, electric start', 'Power trim & tilt', 'Command Link compatible'],
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/9c08c2b9-1f6b-4f51-a54d-5275036588f8.jpg',
    alt: '90 horsepower four-stroke outboard motor on a light background',
  },
];

export const services = [
  {
    title: 'Diagnostics',
    text: 'Year-round drive-in hydraulic test tank plus manufacturer computer diagnostics.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/db0c5d05-06d8-4d0c-9ba9-3e61d2314589.jpg',
    alt: 'Diagnostic laptop cable plugged into an outboard motor with the cowling removed',
    featured: true,
  },
  {
    title: 'Spring Tune-Ups',
    text: 'Get ahead of the season and launch with confidence.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/74e3ed4d-6a9a-476e-b9c8-510ba518a6c1.jpg',
    alt: 'Marine mechanic’s hands tuning an outboard engine with the cowling off',
    featured: false,
  },
  {
    title: 'Winterization',
    text: 'Protect your engine and boat through the off-season.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c6012e18-037d-4e17-b4d3-254475656843.jpg',
    alt: 'Fishing boat shrink-wrapped in white plastic for winter storage',
    featured: false,
  },
  {
    title: 'Regular Maintenance',
    text: 'Scheduled service that keeps small issues small.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/f7393b0e-63ef-49a3-91fe-3cc4bcac42f0.jpg',
    alt: 'Outboard lower unit and propeller throwing spray as a boat accelerates',
    featured: false,
  },
  {
    title: 'Overhauls & Major Repairs',
    text: 'Powerhead and lower unit work done by certified technicians.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/6d200a09-6c53-4cc3-a73f-0c88672d7519.jpg',
    alt: 'Outboard powerhead partially disassembled on a workbench for an overhaul',
    featured: false,
  },
  {
    title: 'Fuel Injector Cleaning',
    text: 'Restore smooth idle, throttle response and fuel economy.',
    image: images.testTank,
    alt: 'Outboard engine running in a water test tank after service',
    featured: false,
  },
  {
    title: 'Electronics & Accessory Installation',
    text: 'Fishfinders, GPS, gauges and accessories installed cleanly.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c322fb5a-bf31-49dc-9c5e-ac1a91c8ec38.jpg',
    alt: 'Technician installing a fishfinder display into a center console',
    featured: false,
  },
];

export const preOwnedSpecs = [
  { label: 'Year', value: '2007' },
  { label: 'Make / Model', value: 'Hurricane 237 Sundeck' },
  { label: 'Engine', value: 'Yamaha F225TXR' },
  { label: 'Engine hours', value: '140' },
  { label: 'Trailer', value: 'LoadRite aluminum' },
];

export const partnerBrands = [
  { name: 'Garmin', src: 'https://img1.wsimg.com/isteam/ip/6aeb6314-f9bd-4040-b2c4-a429ea14e1af/blob-00b3fd6.png' },
  { name: 'Interstate Batteries', src: 'https://img1.wsimg.com/isteam/ip/6aeb6314-f9bd-4040-b2c4-a429ea14e1af/blob-d1c3fec.png' },
  { name: "Land 'N' Sea", src: 'https://img1.wsimg.com/isteam/ip/6aeb6314-f9bd-4040-b2c4-a429ea14e1af/blob-717371b.png' },
  { name: 'Paxton Company', src: 'https://img1.wsimg.com/isteam/ip/6aeb6314-f9bd-4040-b2c4-a429ea14e1af/blob-93e32af.png' },
  { name: 'OBR', src: 'https://img1.wsimg.com/isteam/ip/6aeb6314-f9bd-4040-b2c4-a429ea14e1af/blob-fcea2cf.png' },
];

export const textBrands = ['May-Craft Boats', 'Road King Trailers'];

export const towns = [
  'Edenton',
  'Elizabeth City',
  'Hertford',
  'Williamston',
  'Washington',
  'Greenville',
  'Outer Banks',
  'Virginia Beach',
  'Norfolk',
  'Suffolk',
];

export const gallery = [
  {
    src: images.goldenHour,
    alt: 'Center console boat carving a wake across the sound at sunset',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/909c18b5-6214-450a-839d-49ad0335983d.jpg',
    alt: 'Center console fishing boat with rods rigged, anchored near an inlet at dawn',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/db836539-3ebf-441f-9052-a8a6d013d2cb.jpg',
    alt: 'Weathered dock pilings and a skiff tied up on a calm river at sunset',
  },
  {
    src: images.twinOutboards,
    alt: 'Twin outboards on a transom at sunrise',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/f1f0e55a-3c16-4731-87c6-dcc2fea33d29.jpg',
    alt: 'Flats skiff drifting on a misty sound with cypress trees along the shore',
  },
  {
    src: images.bayBoatMarsh,
    alt: 'Bay boat on glassy water beside golden marsh grass',
  },
];
